import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { AdminCourierLedgerService } from '@/shared/api'

const KEYS = {
  list: (params?: unknown) => ['courier-ledger', 'list', params],
  details: (id: number) => ['courier-ledger', 'details', id],
  problemOrders: (params?: unknown) => ['courier-ledger', 'problem-orders', params],
}

export function useCourierLedger(params?: Record<string, unknown>) {
  return useQuery({
    queryKey: KEYS.list(params),
    queryFn: () => AdminCourierLedgerService.list(params),
    staleTime: 30000,
  })
}

// Заказы, по которым не сформировано начисление (нет тарифа)
export function useProblemOrders(params?: Record<string, unknown>) {
  return useQuery({
    queryKey: KEYS.problemOrders(params),
    queryFn: () => AdminCourierLedgerService.problemOrders(params),
    staleTime: 30000,
  })
}

// Выгрузка журнала начислений в CSV
export function useExportLedger() {
  return useMutation({
    mutationFn: (params?: Record<string, unknown>) =>
      AdminCourierLedgerService.exportCsv(params),
    onError: (error: { alreadyToasted?: boolean; detail?: string }) => {
      if (!error?.alreadyToasted) toast.error(error?.detail || 'Ошибка выгрузки отчёта')
    },
  })
}

export function useCourierLedgerDetails(id: number | null) {
  return useQuery({
    queryKey: KEYS.details(id || 0),
    queryFn: () => AdminCourierLedgerService.details(id as number),
    enabled: !!id,
  })
}

export function useRecalculateLedger() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, newAmount, reason }: { id: number; newAmount: number; reason: string }) =>
      AdminCourierLedgerService.recalculate(id, { new_amount: newAmount, reason }),
    onSuccess: () => {
      toast.success('Перерасчёт создан')
      queryClient.invalidateQueries({ queryKey: ['courier-ledger'] })
    },
    onError: (error: { alreadyToasted?: boolean; detail?: string }) => {
      if (!error?.alreadyToasted) toast.error(error?.detail || 'Ошибка')
    },
  })
}
